import { Menu, MenuItemProps, MenuProps } from "semantic-ui-react";

type BPMenuProps = MenuProps & {}

export function BPMenu(props: BPMenuProps) {
    return <Menu {...props}>
        {props.children}
    </Menu>;
}

type BPMenuItemProps = MenuItemProps & {}

export function BPMenuItem(props: BPMenuItemProps) {
    return <Menu.Item {...props}>
        {props.children}
    </Menu.Item>;
}